// lib/context/TokenExplorerContext.tsx
'use client'
import { TOKEN_EXPLORER_OPTIONS } from '@/components/pages/home/TokenExplorer/config'
import { usePersistentState } from '@/hooks/usePersistentState'
import React, { createContext, useContext, useState, useEffect, useRef } from 'react'

type Ctx = {
  tab: string
  setTab: (v: string) => void
  time: string
  setTime: (v: string) => void
  view: string
  setView: (v: string) => void,
  query: string
  setQuery: (v: string) => void
  chain: string
  setChain: (v: string) => void
  sortBy: string
  setSortBy: (v: string) => void
}
const TokenExplorerCtx = createContext<Ctx | null>(null)

export const TokenExplorerProvider = ({ children }: React.PropsWithChildren) => {
  const [tab, setTab]   = usePersistentState('te_tab',   TOKEN_EXPLORER_OPTIONS.tab[0].value)
  const [time, setTime] = usePersistentState('te_time',  TOKEN_EXPLORER_OPTIONS.time[4].value)
  const [view, setView] = usePersistentState('te_view',  TOKEN_EXPLORER_OPTIONS.view[0].value)
  const [chain, setChain] = usePersistentState('te_chain', TOKEN_EXPLORER_OPTIONS.chain[0].value)
  const [sortBy, setSortBy] = usePersistentState('te_sortBy', TOKEN_EXPLORER_OPTIONS.sortBy[0].value)
  const [query, setQuery] = useState('');
  
  const prevTabRef = useRef<string>(tab)
  useEffect(() => {
    const prev = prevTabRef.current
    if (tab === 'gemspump' && prev !== 'gemspump' && sortBy !== 'lasttrade') {
      setSortBy('lasttrade')
    }
    if (tab !== 'gemspump' && sortBy === 'lasttrade') {
      setSortBy(TOKEN_EXPLORER_OPTIONS.sortBy[0].value)
    }
    prevTabRef.current = tab
  }, [tab, sortBy, setSortBy])
  
  return (
    <TokenExplorerCtx.Provider value={{ tab, setTab, time, setTime, view, setView, query, setQuery, chain, setChain, sortBy, setSortBy }}>
      {children}
    </TokenExplorerCtx.Provider>
  )
}

export const useTokenExplorer = () => {
  const ctx = useContext(TokenExplorerCtx)
  if (!ctx) throw new Error('useTokenExplorer must be used inside <TokenExplorerProvider>')
  return ctx
}
